export const BusinessDates = {
  MONDAY: "settings.profile.business.monday",
  TUESDAY: "settings.profile.business.tuesday",
  WEDNESDAY: "settings.profile.business.wednesday",
  THURSDAY: "settings.profile.business.thursday",
  FRIDAY: "settings.profile.business.friday",
  SATURDAY: "settings.profile.business.saturday",
  SUNDAY: "settings.profile.business.sunday",
};

export const ShortBusinessDates = {
  MONDAY: "Mon",
  TUESDAY: "Tues",
  WEDNESDAY: "Wed",
  THURSDAY: "Thu",
  FRIDAY: "Fri",
  SATURDAY: "Sat",
  SUNDAY: "Sun",
};

export const ScheduleType = {
  ENTIRE_DAY: "ENTIRE_DAY",
  BUSINESS_HOURS: "BUSINESS_HOURS",
};

export const SizeWindow = {
  SMALL: "SMALL",
  MEDIUM: "MEDIUM",
  LARGE: "LARGE",
};

export const PositionWindow = {
  LEFT: "LEFT",
  RIGHT: "RIGHT",
};

export const BadgeTypes = {
  IMAGE_LEFT: "IMAGE_LEFT",
  IMAGE_RIGHT: "IMAGE_RIGHT",
  TEXT_ONLY: "TEXT_ONLY",
  CUSTOM_IMAGE: "CUSTOM_IMAGE",
};

export const LogoTypes = {
  IMAGE_AND_TEXT: "IMAGE_AND_TEXT",
  TEXT_ONLY: "TEXT_ONLY",
  CUSTOM_IMAGE: "CUSTOM_IMAGE",
};

export const TimeFormat = {
  FORMAT_12H: "12H",
  FORMAT_24H: "24H",
};

export const DateFormat = {
  DD_MM_YYYY: "dd/mm/yyyy",
  MM_DD_YYYY: "mm/dd/yyyy",
};

export const MessageStyle = {
  SPEECH_BUBBLES: "SPEECH_BUBBLES",
  SIMPLE_LINES: "SIMPLE_LINES",
};

export const FieldType = {
  TEXT: "TEXT",
  NAME: "NAME",
  EMAIL: "EMAIL",
  PHONE: "PHONE",
  ARENA: "ARENA",
  DROPDOWN: "DROPDOWN",
};

export const TopicType = {
  CHAT_READY: "chat-ready",
  SET_CHAT_TOKEN: "set-chat-token",
  IZI_MESSAGE_NOTIFY: "izi-message-notify",
  CHAT_NOTIFY: "chat-notify",
  INITIALIZED: "initialized",
  REQUEST_TRACKING_INFO: "request-tracking-info",
  TRACKING_INFO: "tracking-info",
  STYLE_IFRAME: "style-iframe",
  VISITOR_CHANGE: "visitor-change",
  GO_TO_TICKET: "chat-open-ticket",
  GO_TO_CHAT: "go-to-chat",
  FILL_INFO: "fill-info",
  FILL_INFO_ERROR: "fill-info-error",
  OPEN_POPUP: "popup-open",
  STYLE: "style",
  CLEAR_CHAT: "clear-chat",
};

export const SessionStatus = {
  CLOSED: "CLOSED",
  SERVED: "SERVED",
  WAITING: "WAITING",
  PENDING: "PENDING",
  NEW: "NEW",
};

export const MessageType = {
  TEXT: "TEXT",
  FILE: "FILE",
  INFO: "INFO",
  NOTIFY: "NOTIFY",
};

export const SessionRating = {
  GOOD: "GOOD",
  BAD: "BAD",
};
